import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [orgs, setOrgs] = useState([]);
    const [activeOrg, setActiveOrg] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data.user);
            setOrgs(data.organizations || []);
            const org = (data.organizations || []).find((o) => o.id === data.user?.active_org_id) || data.organizations?.[0];
            setActiveOrg(org || null);
        } catch (e) {
            setUser(null);
            setOrgs([]);
            setActiveOrg(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("vyastra_token");
        if (token) fetchMe();
        else setLoading(false);
    }, [fetchMe]);

    const login = async (username, password) => {
        const { data } = await api.post("/auth/login", { username, password });
        localStorage.setItem("vyastra_token", data.access_token);
        setUser(data.user);
        setOrgs(data.organizations || []);
        setActiveOrg((data.organizations || []).find((o) => o.id === data.user?.default_org_id) || data.organizations?.[0]);
        return data;
    };

    const logout = () => {
        localStorage.removeItem("vyastra_token");
        setUser(null);
        setOrgs([]);
        setActiveOrg(null);
        window.location.href = "/login";
    };

    const switchOrg = async (orgId) => {
        const { data } = await api.post("/auth/switch-org", { org_id: orgId });
        localStorage.setItem("vyastra_token", data.access_token);
        await fetchMe();
    };

    return (
        <AuthCtx.Provider value={{ user, orgs, activeOrg, loading, login, logout, switchOrg, refresh: fetchMe }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
